export default __webpack_public_path__ + "static/media/TemplateOne.a32ad2ad.jpeg";